export default function () {
    const getName = (type: number): string => {
        switch (type) {
            case 1:
                return "Deck hatch sensor";
            case 2:
                return "Shore power";
            case 14:
                return "Shore power";
            case 3:
                return "Smart plug";
            case 4:
                return "Smoke detector";
            case 5:
                return "CO detector";
            case 6:
                return "Heat detector";
            case 7:
                return "Gas detector";
            case 8:
                return "Water intrusion detector";
            case 9:
                return "Keypad";
            case 10:
                return "Main door sensor";
            case 11:
                return "Immobilizer";
            case 12:
                return "App engine kill";
            case 13:
                return "Gateway";
            case 15:
                return "Gas valve";
            case 16:
                return "Digital output";
            case 17:
                return "Bilge pump";
            case 18:
                return "Tamper detection";
            case 99:
                return "Geofence breach";
            default:
                return "Unknown sensor";
        }
    };

    return {
        getName,
    };
}